import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { useState } from "react";

export const useChatConfirmationModal = () => {
  const [shouldShowConfirmationModal, toggleConfirmationModal] = useBoolean();
  const [
    shouldShowPrivateMessageConfirmationModal,
    togglePrivateMessageConfirmationModal,
  ] = useBoolean();
  const [
    shouldShowPrivateMessageConfirmationOnSubmit,
    setShouldShowPrivateMessageConfirmationOnSubmit,
  ] = useState(false);

  return {
    setShouldShowPrivateMessageConfirmationOnSubmit,
    shouldShowConfirmationModal,
    shouldShowPrivateMessageConfirmationModal,
    shouldShowPrivateMessageConfirmationOnSubmit,
    toggleConfirmationModal,
    togglePrivateMessageConfirmationModal,
  };
};
